import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "./ContactForm.css";
import emailjs from "@emailjs/browser";

const ContactForms = () => {
  const [validated, setValidated] = useState(false);
  const [sent, setSent] = useState(false);

  const [userEmail, setUserEmail] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const publicKey = process.env.REACT_APP_Email_JS_Public_Key;
  const templateKey = process.env.REACT_APP_Email_JS_Template_Key;
  const serviceId = process.env.REACT_APP_Email_JS_Service_ID;

  const handleSubmit = (event) => {
    event.preventDefault();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);
    submitEmail();
  };

  const nameChangeHandler = (event) => {
    setUserEmail((prevState) => {
      return { ...prevState, name: event.target.value };
    });
  };

  const emailChangeHandler = (event) => {
    setUserEmail((prevState) => {
      return { ...prevState, email: event.target.value };
    });
  };

  const subjectChangeHandler = (event) => {
    setUserEmail((prevState) => {
      return { ...prevState, subject: event.target.value };
    });
  };

  const messageChangeHandler = (event) => {
    setUserEmail((prevState) => {
      return { ...prevState, message: event.target.value };
    });
  };

  const submitEmail = () => {
    let test = {
      subject: userEmail.subject,
      from_name: userEmail.name,
      message: userEmail.message,
      reply_to: userEmail.email,
    };

    try {
      emailjs.send(serviceId, templateKey, test, publicKey).then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);

          setSent(true);

          setUserEmail({
            name: "",
            email: "",
            subject: "",
            message: "",
          });

          setValidated(false);
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="contact-form-template">
      <h4>Let's work Together</h4>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="validationCustom01">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Name"
            required
            value={userEmail.name}
            onChange={nameChangeHandler}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="validationCustom02">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            value={userEmail.email}
            onChange={emailChangeHandler}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="validationCustom03">
          <Form.Label>Subject</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter subject"
            value={userEmail.subject}
            onChange={subjectChangeHandler}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="validationCustom04">
          <Form.Label>Brief</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={userEmail.message}
            onChange={messageChangeHandler}
            required
          />
        </Form.Group>

        <Button type="submit">Submit</Button>

        {sent && (
          <p style={{ color: "green", marginTop: "10px", fontWeight: "600" }}>
            Success, message sent.
          </p>
        )}
      </Form>
    </div>
  );
};

export default ContactForms;